var map = {
	"./br/PT/S1/bg116.png": 48296,
	"./br/PT/S2/bg116.png": 11054,
	"./br/PT/bg116.png": 95836,
	"./in/EN/S1/bg116.png": 93603,
	"./in/EN/S2/bg116.png": 71917,
	"./in/EN/bg116.png": 36378,
	"./in/HI/bg116.png": 60843,
	"./mx/EN/S1/bg116.png": 58466,
	"./mx/EN/bg116.png": 35954,
	"./mx/ES/bg116.png": 71717,
	"./ng/EN/S1/bg116.png": 50910,
	"./ng/EN/bg116.png": 85865,
	"./ph/EN/S1/bg116.png": 99048,
	"./ph/EN/bg116.png": 5644,
	"./vn/VI/S1/bg116.png": 6893,
	"./vn/VI/bg116.png": 43777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29890;